import { render, staticRenderFns } from "./NewsMod.vue?vue&type=template&id=7ae2c030&scoped=true"
import script from "./NewsMod.vue?vue&type=script&lang=js"
export * from "./NewsMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2c030",
  null
  
)

export default component.exports